<template>
  <div class="row mt-3">
    <div class="col-lg-8 col-xs-12">
      <Resume :resume="candidate.curriculum_text" :id="candidate.id"/>
      <div class="card card-body mt-3">
        <BigfiveShow
          v-if="candidate.uid"
          :candidate_uid="candidate.uid"
          :no_next="true"
          :only_graph="true"
        />
      </div>
    </div>
    <div class="col-lg-4 col-xs-12">
      <AllApplies :talent_banks_id="candidate.talent_banks_id" />
    </div>
  </div>
</template>

<script>
import Resume from "@/Recruiters/TalentBank/Candidates/Resume.vue";
import AllApplies from "@/Recruiters/TalentBank/Candidates/AllApplies.vue";
import BigfiveShow from "@/Bigfives/Show.vue";
export default {
  props: ["candidate"],
  components: { Resume, AllApplies, BigfiveShow  },
  mounted() {},
};
</script>
